import { render, staticRenderFns } from "./SubjectName.vue?vue&type=template&id=8b4af7ca&"
import script from "./SubjectName.vue?vue&type=script&lang=ts&"
export * from "./SubjectName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports